import type { UserRole } from "@/lib/api";

/** 管理ページ (/admin) は原価など社内向けの情報を扱うため SuperAdmin だけに開く。 */
export function canAccessAdmin(role: UserRole): boolean {
	return role === "SuperAdmin";
}
